import {useLazyQuery} from '@apollo/client';
import {useEffect} from 'react';
import {useAuth} from '@saltus/auth';
import {Version_QUERY} from './versionRefreshQueries';

type VersionQueryResult = {
  version?: string;
};

export const useVersion = (): string | undefined => {
  const [fetchVersion, {data, startPolling}] =
    useLazyQuery<VersionQueryResult>(Version_QUERY);
  const {authStatus} = useAuth();

  useEffect(() => {
    const delayedFetchVersion = setTimeout(() => {
      fetchVersion({
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
        pollInterval: 300000, // 300000 milliseconds = 5 minutes
      });
    }, 5000); // delay initial fetch of version by 5 seconds

    if (authStatus === 'unauthenticated') {
      clearTimeout(delayedFetchVersion);
    }

    return () => clearTimeout(delayedFetchVersion);
  }, [authStatus]);
  return data?.version;
};
